import { createFileRoute } from "@tanstack/react-router";
import SectionOrdersManager from "@/pages/admin/SectionOrdersManager";

export const Route = createFileRoute("/admin/section-orders")({
  component: SectionOrdersManager,
});
